import { cn } from "@/lib/utils";
import { getCurrencyByCode } from "@/lib/data";

/**
 * Renders nothing for an unrecognised code, on purpose. This used to fall back to a gold coin,
 * so a typo in `shop-listings.json` silently showed the reader the wrong currency. Codes are now
 * validated at build time (validate-data.ts `unknownCurrencyCodes`, blocking), so a blank here
 * means the data layer is out of sync — which should fail the build, not lie in the UI.
 */
export function CurrencyIcon({
  currency,
  size = 20,
  className,
}: {
  currency: string;
  size?: number;
  className?: string;
}) {
  const def = getCurrencyByCode(currency);
  if (!def) return null;
  return (
    <img src={def.image} alt="" title={def.name} width={size} height={size} className={cn("shrink-0", className)} />
  );
}
